// extracted by mini-css-extract-plugin
export var gallerySectionContainer = "HeroSection-module--gallerySectionContainer--f144f";
export var header = "HeroSection-module--header--4103f";
export var otherImage = "HeroSection-module--otherImage--d1d4e";
export var section = "HeroSection-module--section--7688b";
export var sectionContainer = "HeroSection-module--sectionContainer--8cb2e";